import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.5 19.75v-16a.75.75 0 0 1 1.5 0v16a.75.75 0 0 1-1.5 0",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m15.646 9.195-.002-.003-.007-.01-.03-.04a31 31 0 0 0-.544-.712 43 43 0 0 0-1.385-1.688c-.535-.616-1.093-1.212-1.587-1.649a4.6 4.6 0 0 0-.635-.486 1 1 0 0 0-.206-.102c-.027.01-.093.034-.206.102a4.6 4.6 0 0 0-.634.486c-.494.437-1.053 1.033-1.588 1.649a43 43 0 0 0-1.929 2.4l-.03.04-.007.01-.002.002a.75.75 0 0 1-1.208-.889l.604.445-.604-.445.012-.016.032-.043a32 32 0 0 1 .565-.739c.37-.475.88-1.11 1.435-1.749.55-.634 1.16-1.288 1.726-1.789.283-.25.573-.477.854-.646.26-.157.607-.323.98-.323.374 0 .72.166.98.323.281.169.571.396.854.646.567.501 1.176 1.155 1.726 1.79a44 44 0 0 1 2 2.487l.032.043.009.012.003.004-.604.445.604-.445a.75.75 0 0 1-1.208.89",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }